import { render, staticRenderFns } from "./ReceivingDetail.vue?vue&type=template&id=afa60002&scoped=true"
import script from "./ReceivingDetail.vue?vue&type=script&lang=js"
export * from "./ReceivingDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceivingDetail.vue?vue&type=style&index=0&id=afa60002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa60002",
  null
  
)

export default component.exports